import { z } from 'zod';

/**
 * Validation du formulaire de connexion.
 *
 * Volontairement **permissive** comparée au schéma d'inscription : à la
 * connexion, on vérifie que les champs sont remplis et que l'email a une forme
 * plausible, rien de plus. Appliquer ici la politique de mot de passe (12
 * caractères, majuscule, chiffre…) refuserait côté client les comptes créés
 * avant un durcissement de cette politique, avec un message incompréhensible
 * pour l'utilisateur.
 *
 * La seule autorité sur la validité des identifiants reste le serveur.
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Renseignez votre adresse e-mail.')
    .email('Cette adresse e-mail semble incorrecte.')
    .trim()
    .toLowerCase(),
  password: z.string().min(1, 'Renseignez votre mot de passe.'),
  rememberMe: z.boolean(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
